/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Spinner from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Spinner from '@fluentui/react-components' instead. */
import { Spinner } from "@fluentui/react/lib/Spinner";

import { spinner } from "./MailListLoading.scss";
import type { JSX } from "react";

const MailListLoading = (): JSX.Element => <Spinner className={spinner}/>;

export default MailListLoading;
